module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACBSURBVAiZdYwhDgIxEEX/0KQ1xVV1PArJNfYaBMV9ylFweE7AAapm1SQVY2YNJBtYvnsvL5+Yubn7GX9GRDcqpexjjE8Ah43mZWannYgoEU0A9CtQIppERAMAqOqcc57fMQDA3a+99/vPNzO3Wqszc1v7sIaU0iOEcDSzyxjDPn4Bw7IrjvST9XAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/arrow1.png
// module id = Nuzj
// module chunks = 1